'use strict';

export default class FutureEventsController 
{
	/*@ngInject*/
	constructor($http, $stateParams) 
	{
		this.$http = $http;
		this.currentPage = 1;
		this.pageSize = 11;
		this.PageChanged();
	}
	
	/*LiveLink(eventid, version)
	{
		if (version <= 1)
			return "https://live.everlaps.com/" + eventid;
		else
			return "https://live" + version + ".everlaps.com/" + eventid;
	}*/

	PageChanged()
	{
		this.eventsPromise = this.$http.post("/api/frontend/events/future-events/" + this.currentPage + "/" + this.pageSize, this.filter)
		.then(response => {
			this.events = response.data;
			this.total = this.events.length > 0 ? this.events[0].total : 0;
		});
	}

	DoSearch(form)
	{
		this.filter = {
			filter: this.nameFilter,
			clubs: this.selectedClubs.map(function(x) {return x.id;}),
			classes: this.selectedClasses.map(function(x) {return x.id;}),
			years: this.selectedYears.map(function(x) {return x.year;})
		};

		this.currentPage = 1;
		this.PageChanged();
	}
}





// WEBPACK FOOTER //
// ./client/app/frontend/events/future_events.controller.js